import ApiClient from './ApiClient';

class InboxMigrations extends ApiClient {
    constructor() {
        super('inboxes', { accountScoped: true });
    }

    migrate(inboxId, targetInboxId) {
        return axios.post(`${this.url}/${inboxId}/migrate`, {
            target_inbox_id: targetInboxId,
        });
    }
}

export default new InboxMigrations();